import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const oneSurveySelector = (state: State) => state.oneSurvey.entities;
export const oneSurveyStatusSelector = (state: State) => state.oneSurvey.status;
export const oneSurveyLoadedSelector = isLoaded(oneSurveyStatusSelector);
export const shouldLoadOneSurveySelector = shouldLoad(oneSurveyStatusSelector);
export const oneSurveyRejectedSelector = isRejected(oneSurveyStatusSelector);
export const oneSurveyPendingSelector = isPending(oneSurveyStatusSelector);
